import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ArtistState } from "explorer/reducers/artistas";
import { Diagnostico } from "shared/interfaces/Diagnostico";
import ShimmerSkeleton from "shared/components/skeleton";

interface CardAssessmentProps {
  diagnostico: Diagnostico;
  OnAccess: () => void;
  formatDate: (date?: string) => string;
}

const CardAssessment: React.FC<CardAssessmentProps> = ({
  diagnostico,
  OnAccess,
  formatDate,
}) => {
  const { t } = useTranslation();
  const { userArtist } = useSelector((state: ArtistState) => state.artists);
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="card-assessment">
      {!imageLoaded && (
        <ShimmerSkeleton
          height={182}
          style={{ flex: "1.5 1 0%", borderRadius: "8px 0 0 8px" }}
        />
      )}
      <img
        alt="artist avatar"
        src={diagnostico?.artistAvatarUrl || userArtist?.profileImage}
        className="image-assessment"
        style={{ display: imageLoaded ? undefined : "none" }}
        onLoad={() => setImageLoaded(true)}
      />
      <div className="content-card-assessment">
        <span className="date">{formatDate(diagnostico?.createdOn)}</span>
        <span className=" name-artist">{diagnostico?.artistName}</span>
        <button
          className="botao-roxo"
          style={{ alignSelf: "flex-start" }}
          disabled={diagnostico?.pendingInvestorAnswer}
          onClick={() => !diagnostico?.pendingInvestorAnswer && OnAccess()}
        >
          {t("pages.Diagnosticos.acessar")}
        </button>
      </div>
    </div>
  );
};

export default CardAssessment;
